import axios from 'axios'
import router from '../router'

export default {
  requestWith (req) {
    let config = {}
    if (!req.hasOwnProperty('url') || !req.hasOwnProperty('method')) {
      req.resultCallback(null)
    }
    config.url = req.url
    config.method = req.method
    config.resultCallback = req.resultCallback
    if (req.hasOwnProperty('data')) {
      config.data = req.data
    }
    if (req.hasOwnProperty('params')) {
      config.params = req.params
    }
    if (req.hasOwnProperty('errorCallback')) {
      config.errorCallback = req.errorCallback
    }
    // 토큰 필요성 체크
    const excludePattern = [
      '/api/user/signup',
      '/api/user/login',
      '/api/user/refreshToken',
      '/api/session',
      '/api/pub/',
      '/api/code',
      '/api/user/checkDuplicate'
    ]
    for (let i = 0; i < excludePattern.length; i++) {
      if (req.url.search(excludePattern[i]) > -1) {
        this.fnCallApi(config)
        return
      }
    }
    if (sessionStorage.accessToken !== 'null' && sessionStorage.accessTokenRefresh !== 'null') { // 클라이언트 세션 있음
      config.headers = {
        'authorization': sessionStorage.accessToken,
        'authorization-refresh': sessionStorage.accessTokenRefresh
      }
      this.fnCallApi(config)
    } else { // 클라이언트 세션 없음
      console.log('클라이언트 세션 없음')
      this.moveLogin()
      // axios.get('/api/ud/getToken')
      //   .then(response => {
      //     // 서버 세션 만료
      //     if (response.data.token == null || response.data.refreshToken == null) {
      //       this.moveLogin()
      //     } else {
      //       if (localStorage.keepLogin === 'true') {
      //         localStorage.accessToken = response.data.token
      //         localStorage.accessTokenRefresh = response.data.refreshToken
      //       }
      //       sessionStorage.accessToken = response.data.token
      //       sessionStorage.accessTokenRefresh = response.data.refreshToken
      //       config.headers = {
      //         'authorization': response.data.token,
      //         'authorization-refresh': response.data.refreshToken
      //       }
      //       this.fnCallApi(config)
      //     }
      //   })
      //   .catch(error => {
      //     console.error(error)
      //     this.moveLogin()
      //   })
    }
  },
  fnCallApi (config) {
    axios(config.url, config)
      .then(response => {
        config.resultCallback(response)
      })
      .catch(error => {
        console.error(error)

        const status = error &&
        error.response &&
        error.response.data
          ? error.response.data.status
          : null

        if (status === 401) {
          console.error('401에러: 토큰 재발급 요청', error)
          this.fnRefreshToken(config)
          return
        }

        if (status === 450) {
          console.error('450에러: 로그아웃 후 로그인 페이지로 이동', error)
          this.moveLogin()
          return
        }

        if (typeof config.errorCallback === 'function') {
          config.errorCallback(error)
          return
        }

        console.error('알 수 없는 에러', error)
      })
  },
  fnRefreshToken (config) {
    if (config.headers.hasOwnProperty('authorization') && config.headers.hasOwnProperty('authorization-refresh')) {
      axios('/api/user/refreshToken', {
        headers: config.headers
      })
        .then(response => {
          if (response.data.resultCode === 1) {
            if (localStorage.keepLogin === 'true') {
              localStorage.accessToken = response.headers['authorization']
              if (response.headers.hasOwnProperty('authorization-refresh')) {
                localStorage.accessTokenRefresh = response.headers['authorization-refresh']
              }
            }
            sessionStorage.accessToken = response.headers['authorization']
            if (response.headers.hasOwnProperty('authorization-refresh')) {
              sessionStorage.accessTokenRefresh = response.headers['authorization-refresh']
            }
            this.requestWith(config)
          } else {
            this.moveLogin()
          }
        })
        .catch(error => {
          console.error(error)
          this.moveLogin()
        })
    } else {
      this.moveLogin()
    }
  },
  moveLogin () {
    sessionStorage.clear()
    sessionStorage.keepLogin = false
    sessionStorage.accessToken = null
    sessionStorage.accessTokenRefresh = null
    localStorage.keepLogin = false
    localStorage.accessToken = undefined
    localStorage.accessTokenRefresh = undefined
    router.replace('/Login')
  }
}



// WEBPACK FOOTER //
// ./src/script/axiosAMS.js